import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSocket } from "../../helper/socket";

// Async action to emit and listen for bet history updates
export const fetchBetHistory = createAsyncThunk(
    "betHistory/fetch",
    async (_, { rejectWithValue }) => {
        return new Promise((resolve, reject) => {
            const socket = getSocket()
            try {
                socket.emit("betHistory"); // Request bet history from the server

                socket.once("bet_history", (data) => {
                    resolve(data); // Resolve when data is received
                });

                // Handle potential timeout
                setTimeout(() => reject(rejectWithValue("No response from server")), 5000);
            } catch (error) {
                reject(rejectWithValue(error.message));
            }
        });
    }
);

const betHistorySlice = createSlice({
    name: "betHistory",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {
        resetBetHistory: (state) => {
            state.data = [];
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBetHistory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBetHistory.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchBetHistory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetBetHistory } = betHistorySlice.actions;
export default betHistorySlice.reducer;
